import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  Box,
  Avatar,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
    logout();
    handleClose();
    navigate('/');
  };

  const isAdmin = user && user.email === 'mertdgn35@gmail.com';
  const isHomePage = location.pathname === '/';

  const menuItems = [
    { label: 'Anılarınız Bizimle Güvende', href: '#top' },
    { label: 'Kontrol Sende', href: '#services' },
    { label: 'Sık Sorulanlar', href: '#courses' },
    { label: 'Sizden Gelenler', href: '#team' },
    { label: 'İletişim', href: '#contact' },
    { label: 'Fiyatlandırma', href: '/pricing' },
  ];

  const menuItemsLogin = [
    { label: 'Anasayfa', href: '/' },
    { label: 'Fiyatlandırma', href: '/pricing' },
  ];

  const drawer = (
    <List>
      {isHomePage && menuItems.map((item) => (
        <ListItem
          button
          key={item.href}
          onClick={() => {
            handleDrawerToggle();
            window.location.href = item.href;
          }}
        >
          <ListItemText primary={item.label} />
        </ListItem>
      ))}
      {!isHomePage && menuItemsLogin.map((item) => (
        <ListItem
          button
          key={item.href}
          onClick={() => {
            handleDrawerToggle();
            window.location.href = item.href;
          }}
        >
          <ListItemText primary={item.label} />
        </ListItem>
      ))}
      {!user && (
        <ListItem
          button
          onClick={() => {
            handleDrawerToggle();
            navigate('/login');
          }}
        >
          <ListItemText primary="Hemen Başla" />
        </ListItem>
      )}
    </List>
  );

  return (
    <AppBar position="sticky">
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          {/* Logo */}
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ cursor: 'pointer', fontWeight: 'bold' }}
            onClick={() => navigate('/')}
          >
            ANISAKLA
          </Typography>

          {/* Menu Items */}
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            {isMobile ? (
              <>
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  edge="start"
                  onClick={handleDrawerToggle}
                >
                  <MenuIcon />
                </IconButton>
                {user && (
                  <IconButton
                    onClick={handleMenu}
                    sx={{ padding: 0, mr: 1 }}
                  >
                    <Avatar
                      alt={user.email}
                      src={user.picture || '/avatar.png'}
                      sx={{ width: 40, height: 40 }}
                    />
                  </IconButton>
                )}
              </>
            ) : (
              <>
                {isHomePage && menuItems.map((item) => (
                  <Button
                    key={item.href}
                    color="inherit"
                    href={item.href}
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'none'
                    }}
                  >
                    {item.label}
                  </Button>
                ))}
                {!isHomePage && menuItemsLogin.map((item) => (
                  <Button
                    key={item.href}
                    color="inherit"
                    href={item.href}
                    sx={{
                      fontWeight: 'bold',
                      textTransform: 'none'
                    }}
                  >
                    {item.label}
                  </Button>
                ))}

                {user ? (
                  <IconButton
                    onClick={handleMenu}
                    sx={{ padding: 0 }}
                  >
                    <Avatar
                      alt={user.email}
                      src={user.picture || '/avatar.png'}
                      sx={{ width: 40, height: 40 }}
                    />
                  </IconButton>
                ) : (
                  <Button
                    color="inherit"
                    onClick={() => navigate('/login')}
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: 'white',
                      color: '#7b6ada',
                      ml: 1,
                      '&:hover': {
                        backgroundColor: '#453c79',
                        color: '#fff'
                      },
                    }}
                  >
                    Hemen Başla
                  </Button>
                )}
              </>
            )}

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem onClick={() => { handleClose(); navigate('/dashboard'); }}>
                Etkinliklerim
              </MenuItem>
              {isAdmin && (
                <>
                  <MenuItem onClick={() => { handleClose(); navigate('/users'); }}>
                    Kullanıcılar
                  </MenuItem>
                  <MenuItem onClick={() => { handleClose(); navigate('/messages'); }}>
                    İletişim Kutusu
                  </MenuItem>
                  <MenuItem onClick={() => { handleClose(); navigate('/event-types'); }}>
                    Etkinlik Türleri
                  </MenuItem>
                  <MenuItem onClick={() => { handleClose(); navigate('/admin/plans'); }}>
                    Paket Ayarları
                  </MenuItem>
                </>
              )}
              <MenuItem onClick={handleLogout}>Çıkış Yap</MenuItem>
            </Menu>

            <Drawer
              variant="temporary"
              anchor="right"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better mobile performance
              }}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 },
              }}
            >
              {drawer}
            </Drawer>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;